import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../core/services';
import {validateAllFormFields} from '../../shared/utils/form.utils';
import { first } from 'rxjs/operators';
import {NgxSpinnerService} from 'ngx-spinner';
import { Router } from '@angular/router';
import {MatDialog} from '@angular/material';
import {TermsDialogComponent} from '../../shared/components/dialogs';
import {passwordPattern} from '../../core/utils/constans';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css', '../login/login.component.css']
})
export class RegisterComponent implements OnInit {
  error: string;
  // registerForm: FormGroup;
  firstForm: FormGroup;
  secondForm: FormGroup;
  loading = false;
  submitted = false;
  step = 1;
  crmId = '';
  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private dialog: MatDialog) {

    this.firstForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]],
    });


    this.secondForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6), Validators.pattern(passwordPattern)]],
      confirm: [false, Validators.required],
    });

    // this.registerForm = this.fb.group({
    //   name: ['', Validators.required],
    //   first_name: ['', Validators.required],
    //   last_name: ['', Validators.required],
    //   email: ['', [Validators.required, Validators.email]],
    //   phone: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]],
    //   password: ['', [Validators.required, Validators.minLength(6), Validators.pattern(passwordPattern)]],
    //   confirm: [false, Validators.required],
    // });
  }

  ngOnInit() {
  }

  saveLead() {
    if (this.firstForm.valid) {
      this.step = 2;
      this.authService.saveLead(this.firstForm.value).subscribe(res => {
        this.crmId = res.id;
        console.log(this.crmId);
      });
    } else {
      validateAllFormFields(this.firstForm);
    }
  }

  onSubmit() {
    this.submitted = true;

    if (this.secondForm.valid) {
      if (this.secondForm.get('confirm').value) {
        this.loading = true;
        this.spinner.show('auth');
        const mergeData = Object.assign(this.secondForm.value, this.firstForm.value);
        mergeData.crmId = this.crmId;
        console.log(this.crmId);
        this.authService.register(mergeData)
            .pipe(first())
            .subscribe(
            data => {
                    this.spinner.hide('auth');
                    this.router.navigateByUrl('/auth/sign-up-success');
                  },
            error => {
                    this.spinner.hide('auth');
                    console.log(error);
                    this.error = error.message;
                    this.loading = false;
                  });
      } else {
        // Confirm is require

      }
    } else {
      validateAllFormFields(this.secondForm);
    }
  }

  openTerms() {
    const dialogRef = this.dialog.open(TermsDialogComponent, {
    });
  }

}
